import React from 'react';

type Props = {
  width?: number;
  height?: number;
  color?: string;
};

const IconMoneyBillMinus: React.FC<Props> = ({
  width = 20,
  height = 20,
  color = '#3E454D',
}: Props) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.7915 15C9.7915 15.345 9.5115 15.625 9.1665 15.625H4.1665C2.1515 15.625 1.0415 14.515 1.0415 12.5V5.83333C1.0415 3.81833 2.1515 2.70833 4.1665 2.70833H14.1665C16.1815 2.70833 17.2915 3.81833 17.2915 5.83333V8.33333C17.2915 8.67833 17.0115 8.95833 16.6665 8.95833C16.3215 8.95833 16.0415 8.67833 16.0415 8.33333V5.83333C16.0415 4.51916 15.4807 3.95833 14.1665 3.95833H4.1665C2.85234 3.95833 2.2915 4.51916 2.2915 5.83333V12.5C2.2915 13.8142 2.85234 14.375 4.1665 14.375H9.1665C9.5115 14.375 9.7915 14.655 9.7915 15ZM3.33317 9.16666C3.33317 9.62666 3.7065 10 4.1665 10C4.6265 10 4.99984 9.62666 4.99984 9.16666C4.99984 8.70666 4.6265 8.33333 4.1665 8.33333C3.7065 8.33333 3.33317 8.70666 3.33317 9.16666ZM9.1665 6.04166C10.8898 6.04166 12.2915 7.44333 12.2915 9.16666C12.2915 10.89 10.8898 12.2917 9.1665 12.2917C7.44317 12.2917 6.0415 10.89 6.0415 9.16666C6.0415 7.44333 7.44317 6.04166 9.1665 6.04166ZM9.1665 7.29166C8.13234 7.29166 7.2915 8.1325 7.2915 9.16666C7.2915 10.2008 8.13234 11.0417 9.1665 11.0417C10.2007 11.0417 11.0415 10.2008 11.0415 9.16666C11.0415 8.1325 10.2007 7.29166 9.1665 7.29166ZM16.0415 13.5417H13.9582C13.6132 13.5417 13.3332 13.8217 13.3332 14.1667C13.3332 14.5117 13.6132 14.7917 13.9582 14.7917H16.0415C16.3865 14.7917 16.6665 14.5117 16.6665 14.1667C16.6665 13.8217 16.3865 13.5417 16.0415 13.5417ZM18.9582 14.1667C18.9582 16.3492 17.1823 18.125 14.9998 18.125C12.8173 18.125 11.0415 16.3492 11.0415 14.1667C11.0415 11.9842 12.8173 10.2083 14.9998 10.2083C17.1823 10.2083 18.9582 11.9842 18.9582 14.1667ZM17.7082 14.1667C17.7082 12.6733 16.4932 11.4583 14.9998 11.4583C13.5065 11.4583 12.2915 12.6733 12.2915 14.1667C12.2915 15.66 13.5065 16.875 14.9998 16.875C16.4932 16.875 17.7082 15.66 17.7082 14.1667Z"
      fill={color}
    />
  </svg>
);

export default IconMoneyBillMinus;
